/*
 state: [id1, id2, ..]
 */

export function clear() {
  return [];
}
